import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { ref } from 'vue';
import HelpList from './HelpList.vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const isShowMenu = ref(false);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "outer",
                onMouseover: _cache[0] || (_cache[0] = ($event) => (isShowMenu.value = true)),
                onMouseleave: _cache[1] || (_cache[1] = ($event) => (isShowMenu.value = false))
            }, [
                _createElementVNode("div", null, [
                    _createVNode(MaterialIcon, {
                        class: "help middle",
                        name: "help"
                    })
                ]),
                _createVNode(HelpList, { "is-show-menu": isShowMenu.value }, null, 8, ["is-show-menu"])
            ], 32));
        };
    }
});
